import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css'; // optional if you want global styles

// Add some debugging for the initial render
console.log("🚀 Application starting up...");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

console.log("📱 App rendered to DOM");